import Model, {
  attr,
  belongsTo,
  type HasMany,
  hasMany,
} from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { Hotel, User } from 'frontend-utils/models';

export default class Userproductaccess extends Model {
  [Type] = 'userproductaccess' as const;

  @belongsTo('user', { async: true, inverse: 'userproductaccess' })
  declare user: User;

  @hasMany('hotel', { async: false, inverse: null })
  declare limitedHotels: HasMany<Hotel>;

  @attr('number') declare count: number;
  @attr('string') declare product: string;
}
